import { render, staticRenderFns } from "./AddFnAreaModal.vue?vue&type=template&id=ee126508&"
import script from "./AddFnAreaModal.vue?vue&type=script&lang=js&"
export * from "./AddFnAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports